import { useTranslation } from 'react-i18next';
import React, { useMemo } from 'react';
import { FieldValues, Control, UseFormSetValue, Controller, useWatch } from 'react-hook-form';

import { Select } from '@/components';

import style from './index.module.scss';
import dayjs from 'dayjs';

type EndTimeProps = {
  onChange?(duration: number): void;
  control: Control<FieldValues, object>;
  duration: number;
  disabled?: boolean;
  setValue: UseFormSetValue<any>;
};

// 0 - 2
const DAYS_OPTIONS = [...Array(4).keys()];
// 0 - 23
const HOURS_OPTIONS = [...Array(24).keys()];
// 0 - 59
const MINUTES_OPTIONS = [...Array(60).keys()];

export const POLL_MIN_DURATION = 5 * 60;

export const EndTime = ({ control, duration, setValue, disabled }: EndTimeProps) => {
  const { t } = useTranslation();

  const time = useWatch({ control, name: 'time' });

  const endTime = useMemo(() => {
    if (!duration) {
      return '';
    }

    return dayjs().add(duration, 'seconds').format('MM/DD HH:mm');
  }, [duration]);

  return (
    <div className={style.endTime}>
      <Controller
        name="time.day"
        control={control}
        render={({ field }) => (
          <Select
            className={style.timeSelect}
            options={DAYS_OPTIONS}
            title={t('Poll_EndTime.19i0n')}
            value={field.value}
            disabled={disabled}
            onChange={v => {
              field.onChange(v);
              if (v === '3') {
                setValue('time.hour', 0);
                setValue('time.minute', 0);
              }
            }}
          />
        )}
      />
      <Controller
        name="time.hour"
        control={control}
        render={({ field }) => (
          <Select
            className={style.timeSelect}
            options={HOURS_OPTIONS}
            title={t('Poll_EndTime.15mju7')}
            value={field.value}
            onChange={field.onChange}
            disabled={disabled || time?.day === '3'}
          />
        )}
      />
      <Controller
        name="time.minute"
        control={control}
        render={({ field }) => (
          <Select
            className={style.timeSelect}
            options={MINUTES_OPTIONS}
            title={t('Poll_EndTime.1fekh')}
            value={field.value}
            onChange={field.onChange}
            disabled={disabled || time?.day === '3'}
          />
        )}
      />
      <div className={style.preEnd}>
        {endTime ? (
          duration < POLL_MIN_DURATION ? (
            <span className={style.isError}>
              {t('Poll_EndTime.lgkeg4', {
                time: dayjs.duration(POLL_MIN_DURATION, 'seconds').humanize(),
              })}
            </span>
          ) : (
            t('Poll_EndTime.endTime', { time: endTime })
          )
        ) : (
          ''
        )}
      </div>
    </div>
  );
};
